var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Filters'),_c('VehicleList',{ref:"vehicleList",on:{"getPageData":_vm.onGetPageData}}),_c('PaginationCompareBtn')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }